import { useEffect, useState } from "react";
import useAxios from "../../../../../../../hooks/useAxios";
import dayjs from "dayjs";
import { DASHBOARDS_ACTIONS_PERFORMANCE_METRICS_CHART } from "../../../../../../../shared/lib/apiEndpointsResolver";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  catchFunction,
  formatToDecimal,
  formatToEurosCurrency,
  formatToTwoDecimalPlaces,
} from "../../../../../../../shared/lib/utils";

const MetricsChart = ({
  params,
  selectedMetric,
  xAxisMinValue,
  xAxisMaxValue,
}) => {
  const axios = useAxios();
  const [data, setData] = useState();
  const unixDateMapping = (value) => {
    return { ...value, date: new dayjs(value.date).unix() };
  };

  const formatDate = (date) => new dayjs(date * 1000).format("DD-MM-YYYY");

  const formatSelectedMetric = (value) => {
    switch (selectedMetric?.value) {
      case "investment":
      case "revenue":
        return formatToEurosCurrency(value);
      case "impressions":
      case "clicks":
      case "sessions":
      case "newUsers":
      case "bounces":
        return formatToDecimal(value);
      case "conversions":
        return formatToTwoDecimalPlaces(value);
      default:
        return value;
    }
  };

  useEffect(() => {
    if (params) {
      axios
        .post(DASHBOARDS_ACTIONS_PERFORMANCE_METRICS_CHART, params)
        .then((response) =>
          setData(response.data.map((item) => unixDateMapping(item))),
        )
        .catch(catchFunction);
    }
  }, [params]);

  return (
    <div id="metricsChartContainer" className="flex flex-row w-full">
      <BarChart
        width={document.getElementById("metricsChartContainer")?.offsetWidth}
        height={300}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          type="number"
          domain={[
            new dayjs(xAxisMinValue).subtract(1, "day").unix(),
            new dayjs(xAxisMaxValue).unix(),
          ]}
          tickFormatter={(value) => formatDate(value)}
        />
        <YAxis />
        <Tooltip
          labelFormatter={(label) => `Fecha: ${formatDate(label)}`}
          formatter={(value) => formatSelectedMetric(value)}
        />
        <Legend />
        <Bar
          type="monotone"
          dataKey={selectedMetric.value}
          fill="#0068ff"
          name={selectedMetric.label}
          barSize={30}
        />
      </BarChart>
    </div>
  );
};

export default MetricsChart;
